module.exports = __webpack_public_path__ + "static/media/bytt-no-7.19207dbf.mp3";